import { atom } from "jotai";
import { type WorkspaceEntity } from "@/api/__generated__/orval/accounts";
import { currentWorkspaceIdAtom } from "./currentWorkspaceId";
import { partnershipWorkspacesAtom } from "./partnershipWorkspaces";
import { workspacesAtom } from "./workspaces";

export const currentWorkspaceAtom = atom<WorkspaceEntity>((get) => {
  const workspaces = get(workspacesAtom);
  const partnershipWorkspaces = get(partnershipWorkspacesAtom);
  const workspaceId = get(currentWorkspaceIdAtom);

  const allWorkspaces = [...workspaces, ...partnershipWorkspaces];

  if (!workspaceId) {
    return allWorkspaces[0];
  }

  return (
    allWorkspaces.find((workspace) => workspace.id === workspaceId) ??
    allWorkspaces[0]
  );
});
